import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { getColumns } from "./Issues-columns.helper";
import ReactTable from "../../ReactTable";

const IssuesTable = ({
   data,
   isLoading,
   onSortChange,
   handleRowClick,
 }) => {	
	const onSort = useCallback(({ sortBy }) => {
		if (onSortChange) {
			if (sortBy.length > 0) {
				const [{ id, desc }] = sortBy;
				onSortChange(`${id} ${desc ? 'desc' : 'asc'}`);
			} else {
				onSortChange();
			}
		}
	}, [onSortChange]);
	
	return (
		<>
			<ReactTable
				columns={getColumns()}
				data={data}
				onSortChange={onSort}
				loading={isLoading}
				manualSortBy
				disableMultiSort
				disableSortBy={true}
				onRowClick={handleRowClick}
			/>
		</>
	);
};

export default withRouter(IssuesTable);
